import axiosInstance from "./axiosInstance";

const getProductsByCategory = async ({
  category,
  pageParam = 1,
}: {
  category: string;
  pageParam?: number;
}) => {
  const accessToken = localStorage.getItem("accessTokenGC");

  try {
    const { data } = await axiosInstance.get(
      `/api/getProductByCategory/${category}?page=${pageParam}&limit=8`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return {
      products: data.products,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching products by category.");
  }
};

export default getProductsByCategory;
